import { Box as MuiBox, Typography as MuiTypography } from "@mui/material";
import PropTypes from "prop-types";
import SidebarSectionHeader from "./SidebarSectionHeader";
import { useTranslation } from "react-i18next";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import BlockIcon from "@mui/icons-material/Block";
import { StudyListingPageStyle } from "./StudyListingPageStyle";
import { useTheme } from "@mui/material/styles";

const StudyRecruitmentSection = ({ recruitmentStatus }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const styles = StudyListingPageStyle(theme);
  return (
    <MuiBox sx={styles.sideBarSection}>
      <SidebarSectionHeader
        title={t("StudyWebisteContentForm.recruitingStatus")}
        helpText={
          "The Recruitment Status value is derived from the OnCore protocol status. If the protocol status is 'Open to Accrual', the recruitment status will be 'Recruiting'. For all other protocol statuses, the recruitment status will be 'Not Recruiting'."
        }
      />

      <MuiTypography
        variant="body2"
        sx={{ display: "flex", alignItems: "center" }}
      >
        {recruitmentStatus ? (
          <>
            <CheckCircleIcon sx={{ mr: 1 }} />
            {t("StudyWebisteContentForm.recruiting")}
          </>
        ) : (
          <>
            <BlockIcon sx={{ mr: 1 }} />
            {t("StudyWebisteContentForm.notRecruiting")}
          </>
        )}
      </MuiTypography>
    </MuiBox>
  );
};

StudyRecruitmentSection.propTypes = {
  recruitmentStatus: PropTypes.bool.isRequired,
};

export default StudyRecruitmentSection;
